export const actions = {
  mainAppLoaded: 'SAGA_MAIN_APP_LOADED'
};

export const FEDOPS_APP_LOADED = 'FEDOPS_APP_LOADED';
